const T = 'PROFILE_SETTINGS.FORM.NOTIFICATIONS';

// BonBoZ: gom 11 loại thông báo thành 3 nhóm.
//
// Trước đây là một danh sách phẳng, nên mỗi nhãn phải tự mang ngữ cảnh — "Tin
// nhắn mới trong hộp thư tôi trực (kể cả chưa phân công)". Tiêu đề nhóm gánh
// phần đó, nhãn còn lại ngắn gọn.
//
// Chia theo PHẠM VI: việc gắn với riêng mình, việc của cả hộp thư, và cam kết
// thời gian.
//
// `email: false` = loại này CHƯA có mẫu email. `EmailNotificationService` gọi
// `mailer.public_send(<tên loại>)`, thiếu hàm là NoMethodError trong job nền —
// tick vào thì hỏng im lặng. Ẩn ô đi cho tới khi có mẫu thật.
export const NOTIFICATION_GROUPS = [
  {
    title: `${T}.GROUPS.MINE`,
    types: [
      {
        label: `${T}.TYPES.CONVERSATION_ASSIGNED`,
        value: 'conversation_assignment',
      },
      {
        label: `${T}.TYPES.ASSIGNED_CONVERSATION_NEW_MESSAGE`,
        value: 'assigned_conversation_new_message',
      },
      {
        label: `${T}.TYPES.PARTICIPATING_CONVERSATION_NEW_MESSAGE`,
        value: 'participating_conversation_new_message',
      },
      {
        label: `${T}.TYPES.CONVERSATION_MENTION`,
        value: 'conversation_mention',
      },
    ],
  },
  {
    title: `${T}.GROUPS.INBOX`,
    types: [
      {
        label: `${T}.TYPES.CONVERSATION_CREATED`,
        value: 'conversation_creation',
      },
      {
        label: `${T}.TYPES.INBOX_CONVERSATION_NEW_MESSAGE`,
        value: 'inbox_conversation_new_message',
        email: false,
      },
      {
        label: `${T}.TYPES.INBOX_CONVERSATION_CALL`,
        value: 'inbox_conversation_call',
        email: false,
      },
      {
        label: `${T}.TYPES.INBOX_CONVERSATION_FRIEND`,
        value: 'inbox_conversation_friend',
        email: false,
      },
      // Lưới an toàn: khách chờ quá 3 phút mà chưa ai trả lời thì nhắc lại cả trang.
      // Bật sẵn cho mọi người; tắt được, nhưng tắt là lưới thủng đúng chỗ đó.
      {
        label: `${T}.TYPES.INBOX_CONVERSATION_WAITING`,
        value: 'inbox_conversation_waiting',
        email: false,
      },
    ],
  },
  {
    title: `${T}.GROUPS.SLA`,
    // Cả nhóm ẩn khi tài khoản chưa bật SLA — xem `NotificationPreferences.vue`.
    requiresSla: true,
    types: [
      {
        label: `${T}.TYPES.SLA_MISSED_FIRST_RESPONSE`,
        value: 'sla_missed_first_response',
      },
      {
        label: `${T}.TYPES.SLA_MISSED_NEXT_RESPONSE`,
        value: 'sla_missed_next_response',
      },
      {
        label: `${T}.TYPES.SLA_MISSED_RESOLUTION`,
        value: 'sla_missed_resolution',
      },
    ],
  },
];

// Danh sách phẳng cho chỗ nào chỉ cần duyệt hết, không quan tâm nhóm.
export const NOTIFICATION_TYPES = NOTIFICATION_GROUPS.flatMap(
  group => group.types
);

export const EVENT_TYPES = {
  ASSIGNED: 'assigned',
  NOTME: 'notme',
  UNASSIGNED: 'unassigned',
};

export const ALERT_EVENTS = [
  {
    value: EVENT_TYPES.ASSIGNED,
    label: 'assigned',
  },
  {
    value: EVENT_TYPES.UNASSIGNED,
    label: 'unassigned',
  },
  {
    value: EVENT_TYPES.NOTME,
    label: 'notme',
  },
];
